<template>
  <v-dialog persistent v-model="value" width="200">
    <v-card color="primary" dark>
      <v-card-text class="pa-1">
        <p class="text-center ma-2">Espera...</p>
        <v-container class="fill-height" fluid>
          <v-row justify="center" align="center" >
            <v-progress-circular
              indeterminate
              color="white"
              :size="60"
            ></v-progress-circular>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'loader',
  props: ['value']
}
</script>
